module.exports = __webpack_public_path__ + "static/img/17.aafc66c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/17.jpg
// module id = giyl
// module chunks = 1